
import { defineComponent } from "vue";
import SkillCard from "../components/SkillCard.vue";
import CertiCard from "../components/CertiCard.vue";
export default defineComponent({
  components: { SkillCard, CertiCard },
});
